import React from "react";

const IMG = `${import.meta.env.BASE_URL}img/cards`;

/**
 * Reference result body for Lucky 7 (lucky7 / plucky7 / lucky7eu / lucky7eu2 / vlucky7) and
 * Amar Akbar Anthony (aaa / aaa2 / vaaa): the round's single card + rdesc rows.
 *   Lucky 7: "winner#odd-even#color#card#line" → Winner / Odd/Even / Color / Card / Line
 *   AAA:     "winner#odd-even#color#under-over#card" → Winner / Odd/Even / Color / Under/Over / Card
 */
export default function Lucky7ResultBody({ t1, variant = "lucky7" }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const isAaa = variant === "aaa";
  const rows = isAaa
    ? [
        ["Winner", desc[0]],
        ["Odd/Even", desc[1]],
        ["Color", desc[2]],
        ["Under/Over", desc[3]],
        ["Card", desc[4]],
      ]
    : [
        ["Winner", desc[0]],
        ["Odd/Even", desc[1]],
        ["Color", desc[2]],
        ["Card", desc[3]],
        ["Line", desc[4]],
      ];

  return (
    <div className={`row row5${isAaa ? "" : " align-items-center"}`}>
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <div className="casino-result-content-item text-center" style={{ alignItems: "flex-end" }}>
              <div className="casino-result-cards">
                {cards[0] !== "1" && (
                  <div className="casino-result-cards-item">
                    <img src={`${IMG}/${cards[0]}.png`} alt="" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {/* lucky5's rdesc has no line part — the reference omits that row (v-if) */}
            {rows.filter(([, value]) => value !== undefined).map(([label, value], i) => (
              <React.Fragment key={label}>
                {i > 0 && " "}
                <div className="casino-result-desc-item">
                  <div>{label}</div> <div>{value}</div>
                </div>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
